import moment from 'moment';
import { getStore } from '@shared/store';
import { WAIT_DURATION_BEFORE_PROMPTING_TO_NOTIFY_PENDING_USERS } from '@shared/styles';
import { API } from '@shared/types/api';
import { notifyPendingUsers } from './notifyPendingUsers';

export async function updatePendingUsers({
  message,
  channelSlug,
  pendingUsers,
}: {
  message: API.ChatMessageFragment;
  channelSlug: string;
  pendingUsers?: API.ShortUserFragment[];
}) {
  if (!pendingUsers || !pendingUsers.length) {
    return;
  }

  const store = getStore();
  const shouldNotify = store.getState().notifyPendingUsers.shouldNotifyFromChannelSlug[channelSlug];
  const lastAnsweredAt =
    store.getState().notifyPendingUsers.lastAnsweredAtFromChannelSlug[channelSlug];
  // we want to prompt the user if:
  // (1) he has not been prompted or
  // (2) last prompt was more than 24h ago
  const waitDuration = WAIT_DURATION_BEFORE_PROMPTING_TO_NOTIFY_PENDING_USERS;
  const shouldPrompt = !lastAnsweredAt || moment().diff(moment(lastAnsweredAt)) > waitDuration;

  if (!shouldPrompt && shouldNotify) {
    notifyPendingUsers(message.id);
    return;
  }

  if (!shouldPrompt && !shouldNotify) {
    return;
  }

  store.dispatch({
    type: 'CHAT:SET_PROMPT_TO_NOTIFY_PENDING',
    value: { channelSlug, messageId: message.id, users: pendingUsers },
  });
}
